var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 211,
    viewBox: "0 0 189 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.23 62.0071L0 84.7451L70.7142 166.861L167.374 104.92L147.23 62.0071Z",
    fill: "#BEAAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.798 197.849L72.6457 118.977L205.706 96.5212L265.941 211L109.798 197.849Z",
    fill: "#FF8A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.546 87.2069L185.772 142.12L219.653 79.4825L175.571 5.18891e-05L131.546 87.2069Z",
    fill: "#06BF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuImage);
export default __webpack_public_path__ + "static/media/menu-image.1a4a83ff3cd4f7247fc7882ba740234e.svg";
export { ForwardRef as ReactComponent };